@if (displayedSrc(); as photo) {
  <img class="avatar avatar--photo" [src]="photo" alt="" (error)="onImageError()" />
} @else {
  <span class="avatar body-sm-semibold">{{ initials() }}</span>
}
